import { Button, IconButton, Tooltip, Typography } from '@material-ui/core'
import { MoreHorizOutlined } from '@material-ui/icons'
import { ArticleSelectorDialogProps } from 'components/Common/ArticleSelector/ArticleSelectorDialog'
import MaterialTags from 'components/Common/ArticleSelector/MaterialTags'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { useDialogManager } from 'features/DialogManager/DialogManager'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import { MaterialActions } from 'store/MaterialSelector/MaterialActions'
import { bomItemMaterialSummarySelector } from '../store/selectors/bomItemMaterialSummarySelector'
import { ProjectEditableStateSelector } from '../store/selectors/ProjectEditableStateSelector'
import { ProjectInBuyerViewSelector } from '../store/selectors/projectInBuyerViewSelector'

type RowMaterialSelectorType = {
  partTypeId: string
  variant: 'materialView' | 'partTypeView'
}

export const PartTypeArticleSelectorButton = (
  props: RowMaterialSelectorType
) => {
  const { t } = useTranslation()
  const { openDialog } = useDialogManager()
  const dispatch = useAppDispatch()
  const materialSummary = useAppSelector(
    bomItemMaterialSummarySelector(props.partTypeId),
    isEqual
  )

  const setArticleDialogOpen = (e) => {
    e.stopPropagation()

    dispatch(MaterialActions.initMaterialSelector([props.partTypeId]))

    openDialog('ArticleSelector', {
      showSaveButton: true,
      isPurchasingPrice: false,
    } as ArticleSelectorDialogProps)
  }

  const isProjectEditable = useAppSelector(ProjectEditableStateSelector)
  const isPortalView = useAppSelector(ProjectInBuyerViewSelector)

  if (isPortalView) return null

  switch (props.variant) {
    case 'materialView': {
      return (
        <Button
          disabled={!isProjectEditable}
          title={`${
            (materialSummary && materialSummary.description) ||
            t('project:material-select-an-article')
          }`}
          disableFocusRipple
          fullWidth
          style={{
            justifyContent: 'flex-start',
            paddingTop: 0,
            paddingBottom: 0,
          }}
          disableElevation
          disableRipple
          // disabled={!props.isEditable}
          onClick={setArticleDialogOpen}
        >
          <div style={{ textAlign: 'left' }}>
            {materialSummary?.id ? (
              <Typography
                color="textSecondary"
                variant="caption"
                component="p"
                gutterBottom
                // noWrap
              >
                {`${materialSummary.id}: ${materialSummary.description}`}
              </Typography>
            ) : (
              <LocalizedTypography
                translationKey="project:material-select-an-article"
                color="textSecondary"
                variant="caption"
                gutterBottom
                component="p"
              >
                select an article
              </LocalizedTypography>
            )}
            {materialSummary?.tokens && (
              <MaterialTags selectedTokens={materialSummary.tokens} />
            )}
          </div>
        </Button>
      )
    }
    case 'partTypeView': {
      return (
        <Tooltip title={t('project:material-select-an-article')}>
          <span>
            <IconButton
              size="small"
              onClick={setArticleDialogOpen}
              disabled={!isProjectEditable}
            >
              <MoreHorizOutlined color="action" />
            </IconButton>
          </span>
        </Tooltip>
      )
    }
  }
}
